import { queryKeys } from '@/lib/query-keys';
import { storage } from '@/lib/storage';
import { apiError, authClient } from '@/lib/api/ts-rest';
import type { CurrentUser } from '@octave/contracts';
import { useQuery } from '@tanstack/react-query';


export const useUser = () => {
  return useQuery<CurrentUser, Error>({
    queryKey: queryKeys.auth.user(),
    queryFn: async () => {
      const res = await authClient.getMe();
      if (res.status !== 200) throw apiError(res, 'Failed to load user');
      return res.body;
    },
    enabled: !!storage.get('accessToken'),
  });
};
